<script lang="ts">
	let { 
		cl = '', 
		n, 
		sortnr, 
		order = 1, 
		headClick, 
		title, 
		align = 'left' 
	} = $props<{
		cl?: string;
		n: number;
		sortnr: number;
		order?: 1 | -1;
		headClick: (n: number) => void;
		title: string;
		align?: string;
	}>();

	import Order from './Order.svelte';
</script>

<div
	class={`sumheader cursor-pointer ${sortnr === n ? 'selected' : ''} ${cl}`}
	onclick={() => headClick(n)}
	onkeypress={() => headClick(n)}
	style={`text-align:${align}`}
	role="button"
	tabindex="0"
>
	{title}
	{#if sortnr === n}<Order {order} />{/if}
</div>

<style>
	.sumheader {
		border-top: 1px solid black;
		border-bottom: 1px solid black;
		padding: 0 0.4em;
		font-weight: bold;
		background: #ccc;
		cursor: pointer;
	}
	.selected {
		background: var(--clr-bg-200, #aaa);
	}
</style>
